import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import NotFoundImage from "../assets/images/Decos/vecteezy_404-landing-page_6549647.svg";

function NotFound() {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate("/");
    };

    useEffect(() => {
        const particleContainer = document.querySelector(".particle-container");

        const createParticle = () => {
            const particle = document.createElement("div");
            particle.classList.add("particle");
            particle.style.left = `${Math.random() * 100}%`;
            particle.style.top = `${Math.random() * 100}%`;

            // Append the particle to the container
            particleContainer?.appendChild(particle);

            // Remove the particle after animation
            setTimeout(() => {
                particle.remove();
            }, 3000); // match the duration of the animation
        };

        // Create particles at intervals
        const interval = setInterval(createParticle, 200);

        // Cleanup particles after component unmounts
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen  text-center">
            <div className="particle-container">
                {/* Static Particles */}
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
            </div>
            {/* Illustration 404 */}
            <div className="flex flex-col items-center">
                <img
                    src={NotFoundImage}
                    alt="Illustration 404"
                    className="max-w-md w-full h-auto"
                />
                {/* Texte principal */}
                <p className="text-gray-700 mt-4 text-lg">
                    Oups ! La page que vous recherchez est introuvable.
                </p>
                <p className="text-gray-500 mt-2 text-base">
                    Vous pouvez revenir à la page d'accueil si vous le souhaitez.
                </p>
            </div>

            {/* Bouton retour */}
            <button
                onClick={goToHome}
                className="mt-8 px-6 py-3 bg-teal-500 text-white font-semibold rounded-lg shadow-md hover:bg-teal-600 transition duration-300"
            >
                Retour à la page d'accueil
            </button>
        </div>
    );
}

export default NotFound;
